import { useEffect } from "react";

import { useCardFunc } from "../../hooks";

import { SimpleGrid } from "@chakra-ui/react";

import { CardColor } from "../../components/Cards/CardColor";

export const BrandPalette = () => {
  let defaultCardColor = [
    { id: 0, num: 1, cardName: "Primary", cardValue: "#DB524D" },
    { id: 1, num: 2, cardName: "Secondary", cardValue: "#1A202C" },
    { id: 2, num: 3, cardName: "Accent", cardValue: "#FFAB4D" },
    { id: 3, num: 4, cardName: "Text", cardValue: "#211C1B" },
  ];

  const {
    card,
    setCard,
    addCard,
    deleteCard,
    handleNameChange,
    handleColorChange,
  } = useCardFunc(defaultCardColor, {
    cardName: "Brand",
    cardValue: "#131215",
  });

  let n = card.length;

  // Saving State Logic
  useEffect(() => {
    let data = localStorage.getItem("BrandPalette");
    if (data) {
      setCard(JSON.parse(data));
    }
  }, [setCard]);

  useEffect(() => {
    localStorage.setItem("BrandPalette", JSON.stringify(card));
  });

  return (
    <>
      <SimpleGrid
        columns={{ md: 2, lg: 3 }}
        spacingX="20px"
        spacingY="28px"
        mb="56px"
      >
        {card.map((val) => {
          return (
            <CardColor
              colorCode={val.cardValue}
              id={val.id}
              num={val.num}
              deleteCard={() => deleteCard(val.id)}
              name={val.cardName}
              handleNameChange={handleNameChange}
              handleColorChange={handleColorChange}
            />
          );
        })}
        {card[n - 1].num === 9 ? (
          ""
        ) : (
          <CardColor create colorCode={"#131215"} addCard={addCard} />
        )}
      </SimpleGrid>
    </>
  );
};
